import { PSCType } from "@/graphql";
import type { ActionButtonType } from "./ActionButton";
import PSCCreate from "@/modules/psc/views/PSCCreate.vue";

const CreateA3A5Button: ActionButtonType = {
  label: "components.eventAction.event.actionButtons.CreateKaizenButton.text",
  disabled: false,
  name: "PSCCreateKaizen",
  modalComponent: PSCCreate,
  modalComponentAdditionalBind: {
    showInModal: true,
    type: PSCType.Kaizen,
  },
};

export default CreateA3A5Button;
